/* eslint-disable no-unused-vars */
import { Box, Typography } from '@mui/material';
import React from 'react';

export default function SearchQuerySummary({
  searchValue,
  filters = [],
  dateFilter = 'default',
  formatFieldLabel
}) {
  const hasSearch = Boolean(searchValue);
  const hasFilters = filters.length > 0;
  const hasDate = dateFilter !== 'default';

  const parts = [];

  if (hasSearch) {
    parts.push(`Tracking Number = "${searchValue}"`);
  }

  if (hasFilters) {
    parts.push(
      filters
        .map((f) => `${formatFieldLabel(f.field)} = "${f.value}"`)
        .join(' AND ')
    );
  }

  if (hasDate) {
    parts.push(`Date = "${dateFilter}"`);
  }

  if (parts.length === 0) return null;

  return (
    <Box mb={2}>
      <Typography variant="subtitle2" color="textSecondary">
        Current Search Query:
      </Typography>
      <Typography variant="body2" fontWeight="bold">
        {parts.join(' AND ')}
      </Typography>
    </Box>
  );
}
